import { useState, useCallback } from 'react';

export const useModalControlProps = (initialVisible = false) => {
  const [visible, setVisible] = useState(initialVisible);

  const open = useCallback(() => setVisible(true), []);
  const close = useCallback(() => setVisible(false), []);

  return {
    visible,
    setVisible,
    open,
    close,
  };
};
